import React, { useContext, useState, useEffect, useRef } from 'react'
import {dataContext,localestr} from '../utils.js'
import icon from '../icons.svg' 

function EditCat({title,Value,typeVal,setVal,disabled=false,style=undefined,id=undefined}){
    const targetRef = useRef()
    //const [currVal, setNewVal] = useState((Value||{id:'',name:''}).id?(Value||{id:'',name:''}).id+' '+(Value||{id:'',name:''}).name:''+(Value||{id:'',name:''}).name);
    const [currVal, setNewVal] = useState((Value||{id:'',name:''}).name);
    const [showDlg, setShow] = useState(1);
    const [currArr, setArr] = useState([]);
    const [currItem, setItem] = useState(-1);
    const [l, setL] = useState(0);
    const [t, setT] = useState(0);
    const [w, setW] = useState(0);

    const node = useRef(null);

    const context=useContext(dataContext)
    const data=context.data[typeVal] || []
    const addTWnd=context.addTWnd
    const msg=context.msg

    const changeHandler=(e)=>{
        //setVal(e)
        setNewVal(e)
        setShow(1)
        setItem(-1)
        if (e.length>1){
            const Arr=data.filter(el=>(el.id.indexOf(e)===0||(el.name||'').toLowerCase().indexOf(e.toLowerCase())!==-1||(el.barcode&&el.barcode.indexOf(e)!==-1))&&!parseInt(el.marked))
            if(Arr.length>10) Arr.splice(10)
            setArr(Arr)
        }
        else if(e.length===0) setVal(null)
        else setArr([])
    }

    const clckHandle=(e)=>{
        if(e&&e.marked==='1') {
            msg(localestr('Об\'єкт помічено на видалення!\nПродовжити?'),localestr('Увага'),[
                {caption:localestr('Так'),action:()=>{setVal(e);setNewVal(e?e.name:'');setShow(0);setItem(-1)}},
                //{caption:localestr('Так'),action:()=>{setVal(e);setNewVal(e?e.id+' '+e.name:'');setShow(0);setItem(-1)}},
                {caption:localestr('Ні'),action:()=>{}}
            ])
            return
        }
        setVal(e)
        setNewVal(e?e.name:'')
        //setNewVal(e?e.id+' '+e.name:'')
        setShow(0)
        setItem(-1)
    }

    const getCoords=(t)=>{
        const r=t.getBoundingClientRect()
        setL(parseInt(r.x))
        setT(parseInt(r.y)+24)
        setW(parseInt(r.width))
    }

    const keyHandler=(e)=>{
        getCoords(e.target)
        if(e.key==='ArrowUp'&&showDlg===1) {
            if(currItem===-1) setItem(0)
            else if(currItem===0) setItem(currArr.length-1)
            else setItem(currItem-1)
        }
        else if(e.key==='ArrowDown'&&showDlg===1) {
            if(currArr.length-1<=currItem) setItem(0)
            else setItem(currItem+1)
        }
        else if(e.key==='Enter'&&showDlg===1&&currArr.length>0) {
            if(currItem===-1) clckHandle(currArr[0])
            else clckHandle(currArr[currItem])
        }
        else if(e.key==='F4') {
            if(e.shiftKey) clckHandle(undefined)
            else openWnd()
        }
    }

    const openWnd=(e)=>{
        if (disabled) return
        setShow(0)
        let curVall={...Value}
        if(curVall){
            const i=data.findIndex((el)=>el.id===curVall.id)
            if(i!==-1) curVall={...data[i]}
        }
        
        if(curVall.parent) addTWnd(localestr('Вибір'),typeVal+'_list',clckHandle,curVall,curVall.parent)
        else addTWnd('Вибір',typeVal+'_list',clckHandle,curVall)
    }

    const lost_focus=()=>{
        setNewVal((Value||{id:'',name:''}).name)
    }

    function setFocus(el){
        if (!el) return
        el.scrollIntoView({behaviour:'smooth'})
    }
    function setFocusM(el){
        if (!el) return
        const par_rect=el.parentNode.getBoundingClientRect()
        const el_rect=el.getBoundingClientRect()
        const top=par_rect.top
        const bottom=par_rect.bottom
        if(el_rect.top+8>bottom) el.scrollIntoView({behaviour:'smooth'})
        else if(el_rect.bottom-8<top) el.scrollIntoView({behaviour:'smooth'})
    }

    useEffect(() => {
        if (context.data[typeVal] === undefined) setTimeout(()=>{context.getData(typeVal)},10+Math.floor(Math.random() * 200)) 
        else if(!currVal){
            let curVall={...Value}
            if(curVall){
                const i=data.findIndex((el)=>el.id===curVall.id)
                //if(i!==-1) setNewVal(data[i].name||'')
                if(i!==-1) setNewVal((data[i].id?data[i].id+' ':'')+data[i].name||'')
                //else setNewVal('')
            } //else setNewVal('')

        }
    // eslint-disable-next-line
    },[context.data[typeVal]])

    useEffect(() => {
        let curVall=null
        if(Value) curVall={...Value}
        if(curVall){
            const i=data.findIndex((el)=>el.id===curVall.id)
            if(i!==-1) setNewVal(data[i].name||'')
            //if(i!==-1) setNewVal((data[i].id?data[i].id+' ':'')+data[i].name||'')
            else if (context.data[typeVal] === undefined) setTimeout(()=>{context.getData(typeVal)},10+Math.floor(Math.random() * 200)) 
        } else setNewVal('')

    // eslint-disable-next-line
    },[Value])

    useEffect(()=>{
        const listener = (event) =>{
            if(event.target.id==='cat_div') setShow(0)
            if (node.current && event.target && node.current.contains(event.target)) return
            setShow(0)
            } 
        if (showDlg) document.addEventListener("mousedown", listener)
        return () => {document.removeEventListener("mousedown", listener)}
    })

    //const Val=(Value||{id:'',name:''}).name
    
    const elId=id||'id'+Math.random()

    if(currArr.length>0&&showDlg===1){
        const items=currArr.map((el,idx)=>{
            let stl={cursor:'pointer',fontSize:'small'}
            if(idx===currItem) {
                stl.background='#9E91F7'
                return(<div key={idx} style={stl} ref={el=>{setFocusM(el)}} onClick={()=>{clckHandle(el)}}>{el.id+' - '+el.name}</div>)
            } else {
                return(<div key={idx} style={stl} onClick={()=>{clckHandle(el)}}>{el.id+' - '+el.name}</div>)
            }
        })
        return(
            <div id='cat_div' ref={node} style={{...style,display:'inline-flex',position:'relative'}} onKeyUp={keyHandler}>
                <input title={title} style={{width:'calc(100% - 26px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} type='text' value={currVal||''} id={elId} disabled={disabled}
                onChange={(e)=>{changeHandler(e.target.value)}} 
                onKeyDown={e=>{if(e.key==='ArrowUp'||e.key==='ArrowDown') {e.preventDefault();e.stopPropagation()}}}
                onBlur={()=>{setNewVal((Value||{id:'',name:''}).name)}} />
                <img className='no-print' style={{marginLeft:'-26px',width:'24px',height:'24px',cursor:'pointer'}} src={icon+'#cat'} alt='' onClick={openWnd}/>
                <div  ref={el=>{setFocus(el);targetRef.current=el;return targetRef}} className='no-print' style={{left:l+'px',top:t+'px',width:w+'px',maxHeight:(window.innerHeight-t)+'px',overflowX:'auto',position:'fixed',background:'#FFFFFF',zIndex:'100'}}>
                    {items}
                </div>
            </div>
        )
    } else {
        return(
            <div id='cat_div' ref={node} style={{...style,display:'inline-flex'}} onKeyUp={keyHandler} onBlur={()=>{setNewVal((Value||{id:'',name:''}).name)}}>
                <input title={title} style={{width:'calc(100% - 26px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} type='text' value={currVal||''} id={elId} disabled={disabled}
                onChange={(e)=>{changeHandler(e.target.value)}} 
                onBlur={lost_focus} />
                <img className='no-print' style={{marginLeft:'-26px',width:'24px',height:'24px',cursor:'pointer',opacity:disabled?0.5:1}} src={icon+'#cat'} alt='' onClick={openWnd}/>
            </div>
        )
    }
}

export default EditCat